export default __webpack_public_path__ + "images/21844784d16345924ee4c5ecd1a2e6d2.png";